import { useCallback } from 'react';
import { useRequest } from '@Hooks/useRequest';
import { API } from '@Services';

export interface FundCustomQuestion {
  id: number;
  question: string;
  question_type: string;
  character_limit?: number;
  help_text?: string;
}

interface FundCustomQuestionsResponse {
  fund_name: string;
  introduction_text: string;
  questions: {
    count: number;
    results: FundCustomQuestion[];
    next: string | null;
    previous: string | null;
  };
}

export const useGetFundCustomQuestions = () => {
  const [fetch, response] = useRequest<FundCustomQuestionsResponse>();

  const getFundCustomQuestions = useCallback(
    (projectFundMatchId: number) =>
      fetch(API.paths.fund_custom_questions(projectFundMatchId), 'get'),
    [fetch],
  );

  return [getFundCustomQuestions, response] as const;
};
